import { createRequiredValidators } from "@xo/client-common";
import { Type11File } from "./Type11File";

export function createType11FileValidators() {
    return [
        ...createRequiredValidators<Type11File>(["code"]),
    ];
}
